import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('incorrect_business_type'),
    differentBusinessType: defineMessage('the_details_you_entered_the_details_are_correct'),
    accountSwitched: defineMessage('the_details_you_entered_the_details_are_correct_1'),
    name: defineMessage('name'),
    country: defineMessage('country'),
    currency: defineMessage('currency'),
    entityType: defineMessage('entity_type_2'),
    accountNumber: defineMessage('account_number_2'),
    sortCode: defineMessage('sort_code_2'),
    company: defineMessage('company'),
    individual: defineMessage('individual'),
    back: defineMessage('back'),
    confirm: defineMessage('confirm'),
};
